<template>
  <ValidationProvider
      tag="div" :class="inline && 'd-flex flex-row'"
      :name="labelText" :rules="getRules()"
      v-slot="{ errors }">
    <label v-if="!inline" :for="getId()">{{ labelText }}</label>
    <select v-model="inputVal" class="form-control">
      <option :value="null" disabled>Kies een {{ labelText }}</option>
      <option
          v-for="dropdownElement in dropdownElements"
          :key="dropdownElement.id"
          :value="dropdownElement.id">{{ dropdownElement.name }}
      </option>
    </select>

    <div v-if="inline" class="pl-3 col-lg-8">
      <span class="text-red">{{ errors[0] }}</span>
    </div>
    <span v-else class="text-red">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  name: "DropDownInputField",
  components: {
    ValidationProvider
  },
  props: {
    value: String,
    labelText: String,
    inline: Boolean,
    required: Boolean,
    id: String,
    dropdownElements: Array
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    getId() {
      return this.id || this.labelText;
    },
    getRules() {
      const rules = [];

      if (this.required) {
        rules.push("required");
      }

      return rules.join('|');
    },
    getInputFieldClass() {
      return this.inline ? "form-control col-lg-4" : "form-control";
    }
  }
};
</script>

<style scoped>

.text-red {
  color: red;
}

</style>